/**
 * Spell school badge icon source, served from the shared DDB media bucket.
 */
export const SPELL_SCHOOL_ICON_BASE_URL =
  "https://media.dndbeyond.com/media/spell-school-icons";

export const getSpellSchoolIconUrl = (
  school: string | null | undefined
): string => `${SPELL_SCHOOL_ICON_BASE_URL}/${school?.toLowerCase() ?? ""}.svg`;
